import React, { Component } from "react";
import SubHeader from "./../../Common/Layout/SubHeader";
import LocationsTable from "./LocationsTable";


class Locations extends Component {
    constructor() {
        super()

        this.state = {
            subHeaderItems: [],
            helpMenuItems: [
            ]
        }
    }

    componentDidMount() {

    }
    render() {
        return (
            <div >
                {/* <SubHeader subHeaderMenuItems={this.state.subHeaderItems} helpMenuItems={this.state.helpMenuItems} showClose={false} /> */}
                <LocationsTable />
            </div>
        );
    }
}


export default Locations;


